
const pickVoice = (voices: SpeechSynthesisVoice[], preferredName?: string) => {
  if (preferredName) {
    const exact = voices.find(v => v.name === preferredName);
    if (exact) return exact;
  }
  const preferredVoiceNames = [
    'David',
    'Google UK English Female',
    'Google UK English Male',
    'Microsoft Sonia Online (Natural) - English (United Kingdom)',
    'Microsoft Hazel - English (United Kingdom)',
    'Microsoft Olivia - English (United Kingdom)',
    'Microsoft Libby Online (Natural) - English (United Kingdom)',
    'Microsoft Maisie Online (Natural) - English (United Kingdom)'
  ];
  return voices.find(v => preferredVoiceNames.includes(v.name)) ||
    voices.find(v => v.lang === 'en-GB' || v.lang.includes('en-GB')) ||
    null;
};

type SpeakOptions = {
  voiceName?: string;
  rate?: number;
  pitch?: number;
};

export const speakText = (text: string, options?: SpeakOptions, retryOnce: boolean = true) => {
  if (typeof window === 'undefined' || !window.speechSynthesis) {
    console.warn("Speech synthesis not supported in this browser.");
    return;
  }

  const isIOS = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/i.test(navigator.userAgent);
  const defaultVoiceName = isIOS ? 'David' : 'Google UK English Female';
  const defaultRate = isIOS ? 1.2 : 1.1;

  // Stop any current speech before starting new one
  window.speechSynthesis.cancel();

  const utterance = new SpeechSynthesisUtterance(text);
  
  // Prefer higher quality local voices when available (browser/OS dependent)
  const voices = window.speechSynthesis.getVoices();
  if (!voices.length && retryOnce) {
    setTimeout(() => speakText(text, options, false), 250);
    return;
  }
  const selectedVoice = pickVoice(voices, options?.voiceName || defaultVoiceName);
  if (selectedVoice) utterance.voice = selectedVoice;

  utterance.lang = 'en-GB';
  utterance.rate = options?.rate ?? defaultRate; // Slightly faster, more natural cadence
  utterance.pitch = options?.pitch ?? 1.05;

  window.speechSynthesis.speak(utterance);
};

export const stopSpeaking = () => {
  if (typeof window !== 'undefined' && window.speechSynthesis) {
    window.speechSynthesis.cancel();
  }
};
